import React from 'react';

// Clubheart (formerly Goal Club / goal sponsor) logo mark. Takes the same
// size/color/className/style props as the mdi-react icons it sits beside, and
// a style.fill overrides color the way it does for those.
const ClubheartIcon = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.53 22.93L3.63 16.5A8.79 8.79 0 0 1 12 1.36A8.79 8.79 0 0 1 20.37 16.5L12.47 22.93A0.75 0.75 0 0 1 11.53 22.93ZM12 21.38L4.58 15.33A7.29 7.29 0 0 1 11.74 2.86A0.75 0.75 0 0 0 12.26 2.86A7.29 7.29 0 0 1 19.42 15.33Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.53 19.06L5.53 14.17A5.79 5.79 0 0 1 12 4.63A5.79 5.79 0 0 1 18.47 14.17L12.47 19.06A0.75 0.75 0 0 1 11.53 19.06ZM12 17.51L6.48 13.01A4.29 4.29 0 0 1 11.58 6.13A0.75 0.75 0 0 0 12.42 6.13A4.29 4.29 0 0 1 17.52 13.01Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.58L7.99 12.16A2.79 2.79 0 1 1 12 8.33A2.79 2.79 0 1 1 16.01 12.16Z"
    />
  </svg>
);

export default ClubheartIcon;
